import { render, staticRenderFns } from "./Reset.vue?vue&type=template&id=d3509d24&scoped=true&"
import script from "./Reset.vue?vue&type=script&lang=js&"
export * from "./Reset.vue?vue&type=script&lang=js&"
import style0 from "./Reset.vue?vue&type=style&index=0&id=d3509d24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3509d24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3509d24')) {
      api.createRecord('d3509d24', component.options)
    } else {
      api.reload('d3509d24', component.options)
    }
    module.hot.accept("./Reset.vue?vue&type=template&id=d3509d24&scoped=true&", function () {
      api.rerender('d3509d24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/views/Reset.vue"
export default component.exports